import React from "react";

export interface SettingTab {
  id: string;
  label: string;
  icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
}

interface SettingTabsProps {
  tabs: SettingTab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
}

const SettingTabs = ({ tabs, activeTabId, onTabChange }: SettingTabsProps) => {
  return (
    <div className="w-full flex gap-3 relative">
      {tabs.map((item) => (
        <button
          key={item.id}
          onClick={() => onTabChange(item.id)}
          className={`flex items-center justify-center gap-2 px-6 py-2 text-sm font-medium z-1 ${
            activeTabId === item.id ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-800"
          }`}
        >
          {React.cloneElement(item.icon, {
            className: `${item.icon.props.className ?? ""} ${
              activeTabId === item.id ? "text-blue-600" : "text-gray-800"
            }`,
          })}
          {item.label}
        </button>
      ))}
      <div className="w-full absolute bottom-0 border border-gray-200"></div>
    </div>
  );
};

export default SettingTabs;
